import React from 'react';
import Lock from '@uber/base-icons/lock';
import ThreeDotsHorizontal from '@uber/base-icons/three-dots-horizontal';
import { useStyletron } from 'baseui';
import { Block } from 'baseui/block';
import { Checkbox, LABEL_PLACEMENT as CHECKBOX_LABEL_PLACEMENT, STYLE_TYPE as CHECKBOX_STYLE_TYPE } from 'baseui/checkbox';
import { StatefulMenu } from 'baseui/menu';
import { PLACEMENT, StatefulPopover } from 'baseui/popover';
import { LabelSmall } from 'baseui/typography';
import { ICON_SIZE } from '../constants';
import type { ActionButtonPropsT } from '../types';
import { ActionButton } from './action-button';
type PropsT = Omit<ActionButtonPropsT, 'onClick'> & {
  onLockClick?: (e: React.ChangeEvent<HTMLInputElement>, locked: boolean) => void;
};
const checkboxOverrides = {
  ToggleTrack: {
    style: ({
      $theme
    }) => ({
      margin: 0,
      width: $theme.sizing.scale800
    })
  },
  Toggle: {
    style: ({
      $theme
    }) => ({
      width: $theme.sizing.scale500,
      height: $theme.sizing.scale500
    })
  },
  Label: {
    style: ({
      $theme
    }) => ({
      display: 'flex',
      gap: $theme.sizing.scale100,
      alignItems: 'center',
      paddingLeft: $theme.sizing.scale500
    })
  }
};
const statefulMenuOverrides = {
  List: {
    style: ({
      $theme
    }) => ({
      width: 'max-content',
      padding: $theme.sizing.scale300,
      zIndex: 2
    })
  }
};
export function MoreActionsButton({
  annotation,
  onLockClick
}: PropsT) {
  const [, theme] = useStyletron();
  const {
    isLocked
  } = annotation;
  const moreOptions = [{
    label: 'Lock annotation',
    component: ({
      isLocked
    }) => {
      return <Checkbox checked={isLocked} checkmarkType={CHECKBOX_STYLE_TYPE.toggle} labelPlacement={CHECKBOX_LABEL_PLACEMENT.right} onChange={e => {
        onLockClick?.(e, e.target.checked);
      }} overrides={checkboxOverrides}>
            <Lock size={ICON_SIZE} color={theme.colors.contentPrimary} />
            <LabelSmall>Lock</LabelSmall>
          </Checkbox>;
    }
  }];
  return <StatefulPopover content={() => <StatefulMenu items={moreOptions} overrides={{
    ...statefulMenuOverrides,
    Option: {
      component: ({
        item
      }) => {
        return <Block onClick={e => e.stopPropagation()}>{item.component({
            isLocked
          })}</Block>;
      }
    }
  }} />} returnFocus autoFocus placement={PLACEMENT.bottomLeft}>
      <ActionButton icon={<ThreeDotsHorizontal size={ICON_SIZE} color={theme.colors.contentPrimary} />} name="More Options" />
    </StatefulPopover>;
}